export default __webpack_public_path__ + "media/calculatorpreview.f322d6215ee066da68431a91b19e1977.webp";